import { computed, type ExtractPropTypes, type PropType } from 'vue';

import { type SizeType, type SizeBreakpointType, sizeList } from '../../typings/sizeType';
import { BreakpointDepended } from '../breakpointDepended';
import { defaults } from '../defaults';

export type SizePropType = SizeType | SizeBreakpointType;

export function withSizeProps(defaultValue?: SizePropType) {
  return {
    /**
     * Rozmiar elementu
     */
    size: {
      type: [String, Object] as PropType<SizePropType>,
      default: defaultValue
    }
  };
}

/**
 * Zwraca klasy rozmiarów
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withSizeProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useSizeProps = (prefix: string, props: ExtractPropTypes<ReturnType<typeof withSizeProps>>) => {
  return computed(() => {
    if (typeof props.size === 'string') {
      return `${prefix}--${props.size}`;
    } else if (BreakpointDepended(props.size).value) {
      return `${prefix}--${BreakpointDepended(props.size).value}`;
    }

    return `${prefix}--${defaults.size}`;
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesSizeArgs = {
  args: {
    size: defaults.size
  },

  argTypes: {
    size: {
      options: sizeList,
      control: { type: 'inline-radio' }
    }
  }
};
